'use strict';

var arIframes = document.querySelectorAll('iframe');
var mainHeaderEl = document.querySelector('.jsMainHeader');
var maxHeight = mainHeaderEl ? window.innerHeight - mainHeaderEl.offsetHeight : window.innerHeight * 0.9;

var _loop = function _loop(i) {
    var iframe = arIframes[i];
    var aspectRatio = getIframeAspectRatio(iframe);

    setIframeAspectRatio(iframe, aspectRatio);
    window.addEventListener('resize', function (_) {
        return setIframeAspectRatio(iframe, aspectRatio);
    });
    window.addEventListener('orientationchange', function (_) {
        return setIframeAspectRatio(iframe, aspectRatio);
    });
};

for (var i = 0; i < arIframes.length; i++) {
    _loop(i);
}

function setIframeAspectRatio(iFrameElement, ratio) {
    iFrameElement.style.height = Math.min(iFrameElement.offsetWidth / ratio[0] * ratio[1], maxHeight) + 'px';
}

function getIframeAspectRatio(iframe) {
    var aspectRatio = iframe.dataset.aspectRatio;
    if (aspectRatio) return aspectRatio.split(':');

    if (iframe.getAttribute('width') && iframe.getAttribute('height')) {
        var definedWidth = iframe.getAttribute('width');
        var definedHeight = iframe.getAttribute('height');

        return [1, definedHeight / definedWidth];
    }

    return [16, 9];
}
function MobileMenu(el) {
    var _this = this;

    this.el = el;

    this.focusedElBeforeOpen = null;
    this.focusableEls = this.el.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    this.firstFocusableEl = this.focusableEls[0];
    this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];

    this.el.addEventListener('click', function (e) {
        if (e.target.classList.contains('jsHideMenu')) _this.hide();
    });

    document.addEventListener('keyup', function (e) {
        if (e.key.toLowerCase() === 'escape') _this.hide();
    });

    window.addEventListener('keydown', function (e) {
        var tabIsPressed = e.key === 'Tab';

        if (!tabIsPressed) return;

        if (e.shiftKey) {
            if (document.activeElement === _this.firstFocusableEl) {
                _this.lastFocusableEl.focus();
                e.preventDefault();
            }
        } else {
            if (document.activeElement === _this.lastFocusableEl) {
                _this.firstFocusableEl.focus();
                e.preventDefault();
            }
        }
    });
}

MobileMenu.prototype.toggleVisibility = function () {
    if (this.el.classList.contains('visible')) this.hide();else this.show();
};

MobileMenu.prototype.show = function () {
    this.el.classList.add('visible');

    // Accessibility stuff
    this.focusedElBeforeOpen = document.activeElement;
    document.body.ariaHidden = true;
    this.el.ariaHidden = false;
    if (this.firstFocusableEl) this.firstFocusableEl.focus();
};

MobileMenu.prototype.hide = function () {
    this.el.classList.remove('visible');

    // Accessibility stuff
    if (this.focusedElBeforeOpen) this.focusedElBeforeOpen.focus();
    this.focusedElBeforeOpen = null;
    document.body.ariaHidden = false;
    this.el.ariaHidden = true;
};

(function () {
    var mobileMenuTriggerEl = document.querySelector('.jsMobileMenuTrigger');
    var mobileMenuEl = document.querySelector('.jsMobileMenu');

    if (mobileMenuTriggerEl && mobileMenuEl) {
        var mobileMenu = new MobileMenu(mobileMenuEl);

        mobileMenuTriggerEl.addEventListener('click', function (e) {
            e.preventDefault();
            mobileMenu.toggleVisibility();
        });
    }
})();
function PageHeader(el) {
    this.el = el;
    this.videoEl = this.el.querySelector('.jsPageHeaderVideo');

    if (this.videoEl) this.initVideo();
}

PageHeader.prototype.initVideo = function () {
    var _this2 = this;

    this.videoAspectRatio = this.videoEl.dataset.aspectRatio.split(':');

    this._setVideoSize();
    window.addEventListener('resize', function (_) {
        return _this2._setVideoSize();
    });
    window.addEventListener('orientationchange', function (_) {
        return _this2._setVideoSize();
    });
};

PageHeader.prototype._setVideoSize = function () {
    this.videoEl.style.width = null;
    this.videoEl.style.height = null;

    var newWidth = window.innerWidth;
    var newHeight = this.videoEl.offsetWidth / this.videoAspectRatio[0] * this.videoAspectRatio[1];

    if (newHeight < this.el.offsetHeight) {
        newHeight = this.el.offsetHeight;
        newWidth = this.el.offsetHeight / this.videoAspectRatio[1] * this.videoAspectRatio[0];
    }

    this.videoEl.style.width = newWidth + 'px';
    this.videoEl.style.height = newHeight + 'px';
};

(function () {
    var pageHeaderEl = document.querySelector('.jsPageHeader');
    if (pageHeaderEl) new PageHeader(pageHeaderEl);
})();
function Accordion(el) {
    var _this3 = this;

    this.el = el;

    this.el.addEventListener('click', function (e) {
        if (e.target.classList.contains('jsAccordionLineTitle')) {
            _this3.toggleElement(e.target.closest('li'));
        }
    });
}

Accordion.prototype.toggleElement = function (el) {
    var _this4 = this;

    if (el.classList.contains('open')) {
        this._closeElement(el);
    } else {
        // Find all open elements and close them
        var openEls = this.el.querySelectorAll('li.open');
        if (openEls) openEls.forEach(function (el) {
            return _this4._closeElement(el);
        });

        // Open this element
        this._openElement(el);
    }
};

Accordion.prototype._openElement = function (el) {
    var oldHeight = el.offsetHeight;

    // Get the element height when expanded
    el.classList.add('open');
    var newHeight = el.offsetHeight;
    el.classList.remove('open');

    gsap.timeline().set(el, { height: oldHeight }).add(function (_) {
        return el.classList.add('open');
    }).to(el, { duration: 0.25, height: newHeight, ease: Power2.easeInOut }).set(el, { clearProps: 'all' });
};

Accordion.prototype._closeElement = function (el) {
    var oldHeight = el.offsetHeight;
    var expandableEl = el.querySelector('.jsAccordionLineExpandable');

    // Get the element height when closed
    el.classList.remove('open');
    var newHeight = el.offsetHeight;
    el.classList.add('open');

    gsap.timeline().set(el, { height: oldHeight }).set(expandableEl, { display: 'block' }).add(function (_) {
        return el.classList.remove('open');
    }).to(el, { duration: 0.25, height: newHeight, ease: Power2.easeInOut }).set([el, expandableEl], { clearProps: 'all' });
};

(function () {
    var accordionEls = document.querySelectorAll('.jsAccordion');
    accordionEls.forEach(function (el) {
        return new Accordion(el);
    });
})();
function SchoolFilms(el) {
    this.el = el;
    this._init();
}

SchoolFilms.prototype._init = function () {
    this.innerEl = this.el.querySelector('[data-inner]');
    this.prevBtnEl = this.el.querySelector('[data-nav-btn="prev"]');
    this.nextBtnEl = this.el.querySelector('[data-nav-btn="next"]');

    this.showHideNav(0);
    this._initModal();
    this._addEventListeners();
};

SchoolFilms.prototype._addEventListeners = function () {
    var _this5 = this;

    // Make sure the inner element does not go out of screen
    window.addEventListener('resize', function () {
        var bounds = _this5.innerEl.getBoundingClientRect();
        var leftOffset = _this5.restrictInnerElPosition(bounds.left);

        if (leftOffset !== bounds.left) {
            gsap.set(_this5.innerEl, { x: leftOffset });
            _this5.showHideNav(leftOffset);
        }
    });

    this.el.addEventListener('click', function (e) {
        if (typeof e.target.dataset.listSchool !== 'undefined') {
            _this5.activateItem(e.target);
        } else if (typeof e.target.dataset.navBtn !== 'undefined') {
            e.preventDefault();

            if (e.target.classList.contains('reverse')) _this5.reverse();else _this5.forward();
        }
    });

    this.el.addEventListener('click', function (e) {
        if (e.target.classList.contains('jsTriggerSchoolModal')) {
            e.preventDefault();

            _this5.showModal(e.target.dataset.title, e.target.dataset.levels, e.target.dataset.embedUrl, e.target.dataset.logoUrl, e.target.dataset.desc, e.target.dataset.url);
        }
    });

    // Modal event listeners
    this.modalEl.addEventListener('click', function (e) {
        if (e.target.classList.contains('jsClose')) {
            _this5.hideModal();
        }
    });

    window.addEventListener('keyup', function (e) {
        if (e.key.toLowerCase() === 'escape') {
            _this5.hideModal();
        }
    });
};

SchoolFilms.prototype.activateItem = function (itemEl) {
    var _this6 = this;

    if (itemEl.classList.contains('is-active')) return;

    // Disable all items
    var items = this.el.querySelectorAll('[data-list-school]');
    items.forEach(function (item) {
        return item.classList.remove('is-active');
    });

    // Activate the current item
    itemEl.classList.add('is-active');

    setTimeout(function () {
        // Make sure that the item is fully on the screen
        var innerBounds = _this6.innerEl.getBoundingClientRect();
        var itemBounds = itemEl.getBoundingClientRect();

        if (itemBounds.right > window.innerWidth) {
            var newPosition = _this6.restrictInnerElPosition(innerBounds.left - (itemBounds.right - window.innerWidth) - 50);

            gsap.to(_this6.innerEl, {
                duration: 0.5,
                x: newPosition,
                ease: 'power2.inOut'
            });

            _this6.showHideNav(newPosition);
        } else if (itemBounds.left < 0) {
            var _newPosition = _this6.restrictInnerElPosition(innerBounds.left - itemBounds.left + 50);

            gsap.to(_this6.innerEl, {
                duration: 0.5,
                x: _newPosition,
                ease: 'power2.inOut'
            });

            _this6.showHideNav(_newPosition);
        }
    }, 300);
};

SchoolFilms.prototype.restrictInnerElPosition = function (value) {
    if (value > 0) return 0;

    var bounds = this.innerEl.getBoundingClientRect();
    if (Math.abs(value) > bounds.width - window.innerWidth) return -(bounds.width - window.innerWidth);

    return value;
};

SchoolFilms.prototype.reverse = function () {
    var bounds = this.innerEl.getBoundingClientRect();

    if (bounds.width < window.innerWidth) {
        gsap.set(this.el, { clearProps: 'all' });
        return;
    }

    var leftOffset = this.restrictInnerElPosition(bounds.left + window.innerWidth * 0.8);

    gsap.to(this.innerEl, {
        duration: 0.5,
        x: leftOffset,
        ease: 'power2.inOut'
    });

    this.showHideNav(leftOffset);
};

SchoolFilms.prototype.forward = function () {
    var bounds = this.innerEl.getBoundingClientRect();

    if (bounds.width < window.innerWidth) {
        gsap.set(this.el, { clearProps: 'all' });
        return;
    }

    var leftOffset = this.restrictInnerElPosition(bounds.left - window.innerWidth * 0.8);

    gsap.to(this.innerEl, {
        duration: 0.5,
        x: leftOffset,
        ease: 'power2.inOut'
    });

    this.showHideNav(leftOffset);
};

SchoolFilms.prototype.showHideNav = function (newLeftPosition) {
    var bounds = this.innerEl.getBoundingClientRect();

    if (bounds.width < window.innerWidth) {
        this.prevBtnEl.disabled = true;
        this.nextBtnEl.disabled = true;

        return;
    }

    if (newLeftPosition === 0) this.prevBtnEl.disabled = true;else this.prevBtnEl.disabled = false;

    if (Math.abs(newLeftPosition) >= bounds.width - window.innerWidth) this.nextBtnEl.disabled = true;else this.nextBtnEl.disabled = false;
};

SchoolFilms.prototype._initModal = function () {
    this.modalEl = document.createElement('div');
    this.modalEl.classList.add('se-school-modal');
    this.modalEl.classList.add('jsClose');

    this.modalEl.innerHTML = '\n        <div class="se-school-modal__inner">\n            <button class="se-school-modal__close-btn jsClose" data-close-modal>Close</button>\n\n            <div class="se-school-modal__title-wrapper">\n                <span class="se-school-modal__title jsTitle"></span>\n                <span class="se-school-modal__subtitle jsSubtitle"></span>\n            </div>\n\n            <div class="se-school-modal__embed-wrapper">\n                <iframe class="jsEmbed" src="" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>\n            </div>\n\n            <div class="se-school-modal__meta">\n                <div class="se-school-modal__col logo jsLogo"></div>\n                <div class="se-school-modal__col jsDesc default-styles"></div>\n                <div class="se-school-modal__col"><a href="" class="se-school-modal__link btn btn--small jsLink" target="_blank"></a></div>\n            </div>\n        </div>\n    ';

    document.body.appendChild(this.modalEl);
};

SchoolFilms.prototype.showModal = function (title, levels, embedUrl, logoUrl, desc, url) {
    this.modalEl.querySelector('.jsTitle').textContent = title;
    this.modalEl.querySelector('.jsSubtitle').textContent = levels;
    this.modalEl.querySelector('.jsEmbed').src = embedUrl;
    this.modalEl.querySelector('.jsLogo').innerHTML = '<img src="' + logoUrl + '" alt="' + title + '" />';
    this.modalEl.querySelector('.jsDesc').innerHTML = desc;
    this.modalEl.querySelector('.jsLink').href = url;
    this.modalEl.querySelector('.jsLink').innerHTML = this.formatUrlForHumans(url);

    this.modalEl.classList.add('is-active');
};

SchoolFilms.prototype.formatUrlForHumans = function (url) {
    url = url.replace('https://', '');
    url = url.replace('www.', '');

    // Remove the last slash
    if (url.substr(-1) === '/') url = url.slice(0, -1);

    return url;
};

SchoolFilms.prototype.hideModal = function () {
    this.modalEl.classList.remove('is-active');
    this.modalEl.querySelector('.jsEmbed').src = '';
};

(function () {
    var schoolFilmEls = document.querySelectorAll('[data-c-school-films]');
    schoolFilmEls.forEach(function (schoolFilmEl) {
        return new SchoolFilms(schoolFilmEl);
    });
})();
function VideoModal(url, title, description) {
    var _this7 = this;

    this.url = url;
    this.embedUrl = url.indexOf('youtube') > -1 ? 'https://www.youtube.com/embed/' + this.url.split('v=')[1] + '?autoplay=1&rel=0' : url;
    this.title = title;
    this.description = description;
    this.iframeEl = null;
    this.focusedElBeforeOpen = null;
    this.focusableEls = null;
    this.firstFocusableEl = null;
    this.lastFocusableEl = null;

    this.createStructure();
    this.addEventListeners();
    this.show();

    // Iframe aspect ratio
    this.setIframeAspectRatio();
    window.addEventListener('resize', function (_) {
        return _this7.setIframeAspectRatio();
    });
    window.addEventListener('orientationchange', function (_) {
        return _this7.setIframeAspectRatio();
    });
};

VideoModal.prototype.createStructure = function () {
    this.el = document.createElement('div');
    this.el.classList.add('video-modal');
    this.el.classList.add('jsCloseModal');
    this.el.ariaHidden = true;

    var string = '';

    string += '<button type="button" class="video-modal__close-btn jsCloseModal">Sluiten</button>';
    string += '<div class="video-modal__inner">';
    if (this.title || this.description) {
        string += '<div class="video-modal__title-wrapper">';
        if (this.title) string += '<span class="title heading-2">' + this.title + '</span>';
        if (this.description) string += '<span class="description">' + this.description + '</span>';
        string += '</div>';
    }

    string += '<div class="video-modal__iframe-wrapper"><iframe src="' + this.embedUrl + '" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>';
    string += '</div>';

    this.el.innerHTML = string;

    this.iframeEl = this.el.querySelector('iframe');

    // Add the modal to the body
    document.body.appendChild(this.el);

    // Accessibility stuff
    this.focusedElBeforeOpen = null;
    this.focusableEls = this.el.querySelectorAll('button, iframe, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    this.firstFocusableEl = this.focusableEls[0];
    this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];
};

VideoModal.prototype.addEventListeners = function () {
    this.keyUpEvent = this.handleKeyupEvent.bind(this);
    this.keyDownEvent = this.handleKeydownEvent.bind(this);
    this.keyUpEvent = this.handleClickEvent.bind(this);

    window.addEventListener('keyup', this.keyUpEvent);
    window.addEventListener('keydown', this.keyDownEvent);
    this.el.addEventListener('click', this.keyUpEvent);
};

VideoModal.prototype.removeEventListeners = function () {
    window.removeEventListener('keyup', this.keyUpEvent);
    window.removeEventListener('keydown', this.keyDownEvent);
    this.el.removeEventListener('click', this.keyUpEvent);
};

VideoModal.prototype.handleKeyupEvent = function (e) {
    if (e.key.toLowerCase() === 'escape') {
        this.hide();
    }
};

VideoModal.prototype.handleKeydownEvent = function (e) {
    var tabIsPressed = e.key === 'Tab';

    if (!tabIsPressed) return;

    if (e.shiftKey) {
        if (document.activeElement === this.firstFocusableEl) {
            this.lastFocusableEl.focus();
            e.preventDefault();
        }
    } else {
        if (document.activeElement === this.lastFocusableEl) {
            this.firstFocusableEl.focus();
            e.preventDefault();
        }
    }
};

VideoModal.prototype.handleClickEvent = function (e) {
    if (e.target.classList.contains('jsCloseModal')) {
        this.hide();
    }
};

VideoModal.prototype.show = function () {
    document.body.classList.add('no-overflow');
    this.el.classList.add('visible');

    this.setIframeAspectRatio();

    // Accessibility stuff
    this.focusedElBeforeOpen = document.activeElement;
    document.body.ariaHidden = true;
    this.el.ariaHidden = false;
    if (this.firstFocusableEl) this.firstFocusableEl.focus();
};

VideoModal.prototype.hide = function () {
    // Set classes
    document.body.classList.remove('no-overflow');
    this.el.classList.remove('visible');

    // Accessibility stuff
    if (this.focusedElBeforeOpen) this.focusedElBeforeOpen.focus();
    this.focusedElBeforeOpen = null;
    document.body.ariaHidden = false;
    this.el.ariaHidden = true;

    // Delete
    this.el.parentElement.removeChild(this.el);
    this.removeEventListeners();
};

VideoModal.prototype.setIframeAspectRatio = function () {
    var aspectRatio = [16, 9];

    this.iframeEl.style.width = null;
    this.iframeEl.style.height = null;

    var newWidth = this.iframeEl.parentElement.offsetWidth;
    var newHeight = Math.min(this.iframeEl.parentElement.offsetWidth / aspectRatio[0] * aspectRatio[1], window.innerHeight * 0.8);

    this.iframeEl.style.width = newWidth + 'px';
    this.iframeEl.style.height = newHeight + 'px';
};

(function () {
    window.addEventListener('click', function (e) {
        if (e.target.classList.contains('jsVideoModalTrigger')) {
            e.preventDefault();
            new VideoModal(e.target.dataset.videoModalUrl, e.target.dataset.videoModalTitle, e.target.dataset.videoModalDesc);
        }
    });
})();